<template>
    <div style="display: flex;height: 100%;padding: 6px;gap: 12px;">
        <StationSide @node-click="nodeClick"/>
        <div style="height: 100%;flex: 1;display: flex;flex-direction: column;">
            <QueryForm ref="queryForm" :dataSource='queryFormData' @search="search" :showClear="false"/>
            <div class="ag-theme-material" style="flex: 1;">
            <ag-grid-vue 
            style="width: 100%; height: 100%;"
            :suppressNoRowsOverlay="true"
            autoSizePadding="10"
            editType="fullRow"
            :rowHeight="40"
            :headerHeight="40"
            :gridReady="onGridReady"
            :columnDefs="columnDefs"
            :rowData="rowData"
            >
            </ag-grid-vue>
        </div>
        <div style="display: flex;justify-content: center;color:white;">
            <PageCustom     
            :current='pageNum'
            :pageSize='pageSize'   
            :total="total"                  
            :showElevator='true'
            :showSizer='true'
            :showTotal='true' 
            :pageSizeChanged="pageSizeChanged"
            :pageChanged="pageChanged"
            ></PageCustom>
        </div>
    </div>
    <ELDialog ref="ELDialogRef" :closeCallBack="resetForm">
        <template slot="mytitle">
            <span>{{ title }}</span>
        </template>
        <template slot="mybody">
            <div>
                <div style="display: flex;align-items: center;margin-bottom: 10px;gap: 10px;">
                    <Select @on-change="dialogSearch" v-model="value" style="width:200px;">
                        <Option v-for="item in options" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    <Button type="primary" @click="dialogSearch">查询</Button>
                </div>
                <div class="ag-theme-material" style="min-height: 200px;">
                    <div style="display: flex;gap:10px;padding: 10px;flex-direction: column;" v-if="value!=='/api/water/getAnalyzerLog/byTime'">
                        <div  style="display: flex;" v-for="(item,index) in resData">
                            <div style="color: white;">{{ item.label }}：</div>
                            <div style="color: white;" v-if="item.type=='string'">
                                {{ isNull(data[item.prop],item) }}{{ item.unit }}
                            </div>
                            <div style="color: white;" v-else-if="item.type=='object'">
                                {{ isNull(item.object[data[item.prop]],item) }}{{ item.unit }}
                            </div>
                        </div>
                    </div>
                    <template v-else>
                        <ag-grid-vue 
                        style="width: 100%; height: 400px;"
                        :suppressNoRowsOverlay="true"
                        autoSizePadding="10"
                        editType="fullRow"
                        :rowHeight="40"
                        :headerHeight="40"
                        :gridReady="onGridDialogReady"
                        :columnDefs="dialogColumnDefs"
                        :rowData="dialogRowData"
                        >
                        </ag-grid-vue>
                        <div style="display: flex;justify-content: center;color:white;">
                            <PageCustom     
                            :current='dialogPageNum'
                            :pageSize='dialogPageSize'   
                            :total="dialogTotal"                  
                            :showElevator='true'
                            :showSizer='true'
                            :showTotal='true' 
                            :pageSizeChanged="dialogPageSizeChanged"
                            :pageChanged="dialogPageChanged"
                            ></PageCustom>
                        </div>
                    </template>
                    <Spin size="large" fix :show="true" v-if="spinShow"></Spin>
                </div>
            </div>
        </template>
    </ELDialog>
</div>
</template>

<script>
import AgGridVueCustomTsx, { ColDefCustom } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import ELDialog from 'src/components/ELDialog.vue';
import axios from 'axios';
import StationSide from '@/pages/systemMessage/components/stationSide.vue';
import { all_data, get_water_collection_info } from './api';
import QueryForm from 'src/components/queryForm/queryForm';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import PageCustom, { PageCustomProps } from 'src/components/pageCustom/pageCustom.tsx';
export default {
    components: {
        AgGridVueCustomTsx,
        CellRenderTsx,
        ELDialog,
        StationSide,
        QueryForm,
        PageCustom,
    },
    data() {
        return {
            value: '/monitor/hunan/get_water_collection_info',
            resData: [],
            options: [
                {
                    value: '/monitor/hunan/get_water_collection_info',
                    api: get_water_collection_info,
                    label: '取水',
                    type: '1',
                    resData: [
                        {
                            prop: 'data_time',
                            label: '采样时间',
                            type: 'string',
                        },
                        {
                            prop: 'duration',
                            label: '实际采水时长',
                            type: 'string',
                        },
                        {
                            prop: 'current_pump',
                            label: '当前水泵1号',
                            type: 'string',
                        },
                        {
                            prop: 'water_color',
                            label: '水体颜色',
                            type: 'string',
                        },
                        {
                            prop: 'floating_debris',
                            label: '取水点漂浮物',
                            type: 'object',
                            object: {
                                '0': '没有漂浮物',
                                '1': '有漂浮物',
                            },
                        },
                        {
                            prop: 'water_depth',
                            label: '断面水位',
                            type: 'string',
                        },
                    ],
                },
                {
                    value: '/api/water/rtd/getPretreatmentInfo/byTime',
                    label: '预处理',
                    type: '2',
                    resData: [
                        {
                            prop: 'settlementMode',
                            label: '沉降模式',
                            type: 'object',
                            object: {
                                '0': '时间沉降',
                                '1': '动态沉降',
                            },
                        },
                        {
                            prop: 'settlingTime',
                            label: '沉降时间',
                            type: 'string',
                        },
                        {
                            prop: 'rawWaterValue',
                            label: '原水浊度',
                            type: 'string',
                        },
                        {
                            prop: 'afterSettlingValue',
                            label: '沉降后浊度',
                            type: 'string',
                        },
                    ],
                },
                {
                    value: '/api/water/keyParams/byTime',
                    label: '关键参数',
                    type: '2',
                    resData: [
                        {
                            prop: 'MeasurementInterval',
                            label: '测量间隔',
                            type: 'string',
                            unit: 's',
                        },
                        {
                            prop: 'MeasurementAccuracy',
                            label: '测量精度',
                            type: 'string',
                        },
                        {
                            prop: 'DissolvingTemperature',
                            label: '消解温度',
                            type: 'string',
                        },
                        {
                            prop: 'DissolutionDuration',
                            label: '消解时长',
                            type: 'string',
                        },
                        {
                            prop: 'UpperRangeLimit',
                            label: '仪器量程上限',
                            type: 'string',
                        },
                        {
                            prop: 'CurveSlope',
                            label: '曲线斜率',
                            type: 'string',
                        },
                        {
                            prop: 'CurveIntercept',
                            label: '曲线截距',
                            type: 'string',
                        },
                        {
                            prop: 'CalibrationDateForStandard1',
                            label: '标1校准日期',
                            type: 'string',
                        },
                        {
                            prop: 'MeasurementProcessValue',
                            label: '测量过程值',
                            type: 'string',
                        },
                        {
                            prop: 'CalibrationDateForStandard2',
                            label: '标2校准日期',
                            type: 'string',
                        },
                        {
                            prop: 'DetectionLimit',
                            label: '检出限值',
                            type: 'string',
                        },
                        {
                            prop: 'ColorDevelopmentTemperature',
                            label: '显色温度',
                            type: 'string',
                        },
                        {
                            prop: 'ColorDevelopmentTime',
                            label: '显色时间',
                            type: 'string',
                        },
                        {
                            prop: 'HealthScore',
                            label: '健康度',
                            type: 'string',
                        },
                    ],
                },
                {
                    value: '/api/water/getMovableringInfo/byTime',
                    label: '动环参数',
                    type: '2',
                    resData: [
                        {
                            prop: 'ImmersionState',
                            label: '水浸状态',
                            type: 'string',
                        },
                        {
                            prop: 'Smoke',
                            label: '烟雾',
                            type: 'string',
                        },
                        {
                            prop: 'Temperature',
                            label: '环境温度',
                            type: 'string',
                        },
                        {
                            prop: 'Humidity',
                            label: '环境湿度',
                            type: 'string',
                        },
                    ],
                },
                {
                    value: '/api/water/getAnalyzerLog/byTime',
                    label: '日志',
                    type: '2',
                    isTable: true,
                },
            ],
            queryFormData: [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 300,
                    realField: ['start_time', 'end_time'],
                    timeType: 'number',
                    props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
                },
            ],
            pageNum: 1,
            dialogPageNum: 1,
            pageSize: 20,
            dialogPageSize: 20,
            total: 0,
            dialogTotal: 0,
            gridApi: null,
            dialogLoading: false,
            title: '',
            inline: false,
            spinShow: false,
            form: {},
            formData: [],
            clickFormData: {},
            columnDefs: [],
            rowData: [],
            dialogColumnDefs: [
                {
                    headerName: '序号',
                    field: 'DateTime',
                    width: 50,
                    cellRendererFramework: CellRenderTsx,
                    cellRendererFrameworkOpt: {
                        cellRender(h, params) {
                            return h('span', params.rowIndex + 1);
                        },
                    },
                },
                {
                    headerName: '数据时间',
                    field: 'dataTime',
                },
                {
                    headerName: '日志内容',
                    field: 'logContent',
                },
            ],
            dialogRowData: [],
            stationData: {},
            data: {},
            gridApi:null,
            gridDialogApi:null,
        };
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api;
            params.api.sizeColumnsToFit();
        },
        onGridDialogReady(params) {
            this.gridDialogApi = params.api;
            params.api.sizeColumnsToFit();
        },
        isNull(str, item) {
            if (str == null || str == undefined || str == '') {
                return '--';
            } else {
                if (item.toFiexd) {
                    return Number(str).toFixed(item.toFiexd);
                } else {
                    return str;
                }
            }
        },
        dialogSearch() {
            const data = this.options.find(e => e.value == this.value);
            this.resData = data.resData || [];
            this.spinShow = true;
            if (data.type == '1') {
                data.api(this.form)
                    .then(res => {
                        if (res.code == 0) {
                            this.data = res.data||{};
                        } else {
                            this.data = {};
                        }
                    })
                    .catch(err => {
                        this.$Message.error('查询失败');
                        this.data = {};
                    })
                    .finally(() => {
                        this.spinShow = false;
                    });
            } else {
                if (data.isTable) {
                    axios
                        .post(`${this.stationData.api}${data.value}`, {
                            ...this.form,
                            pageNum: this.dialogPageNum,
                            pageSize: this.dialogPageSize,
                        })
                        .then(res => {
                            if (res.data.code == 200) {
                                // this.data = res.data.data;
                                this.dialogRowData = res.data.data.list;
                                this.dialogTotal = res.data.data.total;
                                this.$nextTick(() => {
                                    this.gridDialogApi.sizeColumnsToFit();
                                });    
                            } else {
                                this.$Message.error('查询失败');
                                this.dialogRowData = [];
                                this.dialogTotal = 0;
                            }
                        })
                        .catch(err => {
                            this.$Message.error('查询失败');
                            this.dialogRowData = [];
                            this.dialogTotal = 0;
                        })
                        .finally(() => {
                            this.spinShow = false;
                        });
                } else {
                    axios
                        .post(`${this.stationData.api}${data.value}`, this.form)
                        .then(res => {
                            if (res.data.code == 200) {
                                this.data = res.data.data;
                            } else {
                                this.$Message.error('查询失败');
                                this.data = {};
                            }
                        })
                        .catch(err => {
                            this.$Message.error('查询失败');
                            this.data = {};
                        })
                        .finally(() => {
                            this.spinShow = false;
                        });
                }
            }
        },
        pageSizeChanged(pageSize) {
            this.pageSize = pageSize;
            this.search()
        },
        dialogPageSizeChanged(pageSize) {
            this.dialogPageSize = pageSize;
            this.dialogSearch();
        },
        pageChanged(pageNum) {
            this.pageNum = pageNum;
            this.search()
        },
        dialogPageChanged(pageNum) {
            this.dialogPageNum = pageNum;
            this.dialogSearch();
        },
        async search() {
            const { code, data } = await all_data({
                ...this.$refs.queryForm.getQueryObj(),
                page_index: this.pageNum,
                page_size: this.pageSize,
                mn: this.stationData.mn,
            });
            if (code == 0) {
                this.total=data.page_count
                this.rowData = data.body;
                this.columnDefs = [
                    {
                        headerName: '序号',
                        field: 'DateTime',
                        width: 50,
                        cellRendererFramework: CellRenderTsx,
                        cellRendererFrameworkOpt: {
                            cellRender:(h, params)=> {
                                return h('span',(this.pageNum-1)*this.pageSize+params.rowIndex+1);
                            },
                        },
                    },
                    {
                        headerName: '时间',
                        field: 'DateTime',
                    },
                    ...data.header.map(e => {
                        return {
                            headerName: `${e.name}(${e.unit})`,
                            field: e.key,
                            cellRendererFramework: CellRenderTsx,
                            cellRendererFrameworkOpt: {
                                cellRender: (h, params) => {
                                    return h(
                                        'span',
                                        {
                                            class: {
                                                'wqms-cursor': true,
                                                'wqms-link': true,
                                            },
                                            on: {
                                                click: () => this.clickHandler(params, e.key, e.name, e.unit),
                                            },
                                        },
                                        `${params.value}${params.data[e.key.slice(0, -4) + '-Flag']}`,
                                    );
                                },
                            },
                        };
                    }),
                ];
                this.$nextTick(() => {
                    this.gridApi.sizeColumnsToFit()
                });
            }
        },
        nodeClick(item) {
            // console.log('点击了节点:', item);
            this.stationData = item;
            // this.form.mn = '123456';
            this.form.mn = this.stationData.mn;
            this.search();
        },
        save() {},
        clickHandler({ data }, key, name, unit) {
            this.title = `${name} ${data.DateTime.slice(0, -4)} ${data[key]}${unit}`;
            // this.form.data_time = '2025-11-07 12:00:00';
            this.form.data_time = data.DateTime.slice(0, -4).replace(/\//g, '-');
            // this.form.dataTime = '2025-10-30 16:00:00';
            this.form.dataTime = data.DateTime.slice(0, -4).replace(/\//g, '-');
            // this.form.polId = 'w20144';
            this.form.polId = key.slice(0, -4);
            this.form.mn = this.stationData.mn;
            this.$refs.ELDialogRef.show();
            this.dialogSearch();
        },
        resetForm() {
            this.form = {};
            this.formData = [];
        },
        cancel() {
            this.$refs.ELDialogRef.handleClose();
        },
    },
};
</script>

<style scoped lang="less">
</style>
